
<section class="quick-setup">
    <div class="quick-setup-header">
        <span>Quick Set up</span>
    </div>
    <div class="setup-items">
        <div class="item-headers">
            <div class="item-label">
                <span>Swift</span>
                <app-tooltip placement="right" >
                    <i class="infoIcon material-icons info-icon" trigger>info_outline</i>
                <div content class="quick-setup-toottip">
                    <span>
                        <strong>Swift </strong>  is a convenient investment option allowing you to automatically invest your wallet funds into the loan(s) without any intervention from your end.
                    </span>
                </div>
                </app-tooltip>
            </div>
            <div class="item-toggle">
                <label class="quick-toggle">
                    <input class="toggle-input" type="checkbox" [(ngModel)]="isSwiftOn" (ngModelChange)="onTogglePreference($event, 'isSwiftOn')" />
                    <span class="slider round"></span>
                </label>
            </div>
        </div>
        <div class="item-description">
            Enable / Disable auomated investments
        </div>
    </div>
    <div class="setup-items">
        <div class="item-headers">
            <div class="item-label">
                <span>nCash</span>
                <app-tooltip placement="right">
                    <i class="infoIcon material-icons info-icon" trigger>info_outline</i>
                <div content class="quick-setup-toottip">
                    <span>
                       <strong> nCash </strong> provides you an option to withdraw a fixed or a 
                       customized amount periodically from your <strong> finzyFLEX </strong> investments.
                    </span>
                </div>
                </app-tooltip>
            </div>
            <div class="item-toggle">
                <label class="quick-toggle">
                    <input class="toggle-input" type="checkbox" [(ngModel)]="isNCashOn" (ngModelChange)="onTogglePreference($event, 'isNCashOn')" />
                    <span class="slider round"></span>
                </label>
            </div>
        </div>
        <div class="item-description">
            Enable / Disable periodic cashflow
        </div>
    </div>
</section>